//////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.image_collection = abcsetup.image_collection || {};
abcsetup.image_collection.item_image_request = abcsetup.image_collection.item_image_request || {};
abcsetup.image_collection.item_image_request.index = abcsetup.image_collection.item_image_request.index || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.image_collection.item_image_request.index.table = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.image_collection.item_image_request.index = {
    init() {
        abcsetup.setTitle('Request Item Images');

        this._bindSupplierSelect();
        this._bindPOGPredomSelect();
        this._setupCheckAllToggle();
        this._setupContactsModals();
        this._setupImageRequestModals();
        this._setupRequestImagesButtonTextChanges();
        this._bindFormSubmit();
    },

    /**
     * Update the table's url whenever the Supplier dropdown's value changes.
     *
     * @private
     */
    _bindSupplierSelect() {
        const _this = this;

        $('select[name=vendor]').on('change', function () {
            const supplierId = $(this).find(':selected').attr('value');
            const newUrl = abcsetup.replaceUrlParameter('vendor', supplierId, $("#itemimagerequest-table").dataTable().api().ajax.url());

            $("#itemimagerequest-table").dataTable().api().ajax.url(newUrl).load();
        });
    },

    /**
     * Update the table's url whenever the Predom. Planogram dropdown's value changes.
     *
     * @private
     */
    _bindPOGPredomSelect() {
        const _this = this;

        $('select[name=pog_predom]').on('change', function () {
            const value = $(this).find(':selected').attr('value');
            const newUrl = abcsetup.replaceUrlParameter('pog_predom', value, $("#itemimagerequest-table").dataTable().api().ajax.url());

            $("#itemimagerequest-table").dataTable().api().ajax.url(newUrl).load();
        });
    },

    _setupCheckAllToggle() {
        $(document).on('click', 'th.checkboxes', () => {
            const checkboxesColumn = $("#itemimagerequest-table").dataTable().api().columns('.checkboxes');
            const header = checkboxesColumn.header().to$();
            const checkThem = !header.data('all-checked');

            // Update header
            header.data('all-checked', checkThem);
            checkThem ? header.addClass('text-primary') : header.removeClass('text-primary');

            // Update checkboxes
            this._getItemRowCheckboxes().prop('checked', checkThem).trigger('change');
        });
    },

    /**
     * Whenever and item's checkbox is checked, enable or disable the request images button depending on if we have any checked items.
     *
     * @private
     */
    _setupRequestImagesButtonTextChanges() {
        const requestImagesBtn = $('#request_images_btn');
        const originalButtonText = requestImagesBtn.text();
        var _this = this;

        $(document).on('change', ':checkbox', () => {
            const numChecked = _this._getItemRowCheckboxes().filter(':checked').length;
            requestImagesBtn.attr('disabled', numChecked === 0);
            requestImagesBtn.text(numChecked > 0 ? `${originalButtonText} (${numChecked})` : originalButtonText);
        });

    },

    /**
     * Get all the item checkboxes.
     *
     * @returns {*}
     * @private
     */
    _getItemRowCheckboxes() {
        return $("#itemimagerequest-table").find(':checkbox');
    },

    /**
     * Get all of the checked item ids.
     *
     * @returns {*}
     * @private
     */
    _getItemRowCheckedValues() {
        return this._getItemRowCheckboxes().filter(':checked').toArray().map(el => $(el).val())
    },

    /**
     * Save changes to supply issues for the items on the current page.
     * @private
     */
    _bindFormSubmit() {
        const _this = this;
        const defaultRequestComments = abcsetup.userRole.class === 'promo_image_reviewer'
            ? 'Please provide Glamour shots.'
            : 'Please provide Planogram images.';

        const submitForm = comments => {
            abcsetup.blockUI(true);

            const formData = new FormData();
            this._getItemRowCheckedValues().forEach(itemId => formData.append('items[]', itemId));
            formData.set('comments', comments);

            axios.post('/api/image_collection/item_image_request', formData)
                .then(response => {
                    $("#itemimagerequest-table").dataTable().api().ajax.reload(); // Once this is done, the UI will be un-blocked.
                    abcsetup.alerts.flashMessage(response.data.success);
                });
        }

        $('#request_images_form').on('submit', function () {
            abcsetup.alerts.prompt(
                'Image Request',
                'Comments (these comments will be displayed to the supplier for each item)',
                ([ok, comments]) => ok && submitForm(comments),
                true,
                false,
                {
                    textarea: true,
                    defaultValue: defaultRequestComments
                })

            return false;
        });
    },

    _setupContactsModals() {
        $(document).on('click', '.supplier_contacts_btn', function () {
            abcsetup.blockUI(true);

            const supplierName = $(this).data('supplier_name').trim();

            axios.get(`/api/users/supplier_contacts/${$(this).data('supplier_id')}?role_classes=vendor`)
                .then(response => {
                    abcsetup.unblockUI();

                    const contacts = response.data.contacts.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
                    let title = supplierName ? (supplierName + ' Contacts') : 'Contacts';
                    let body = '<em>None</em>';

                    if (contacts.length > 0) {
                        title += ` (${contacts.length})`;
                        body = `<table class="table table-sm table-hover">
                                    ${contacts.map(contact => `<tr><td>${contact.name}</td><td>${contact.email}</td></tr>`).join('')}
                                </table>`;
                    }

                    abcsetup.alerts.show(title, body);
                });
        });
    },

    _setupImageRequestModals() {
        $(document).on('click', '.latest_item_image_request_btn', function () {
            abcsetup.blockUI(true);

            axios.get(`/api/image_collection/item_image_request/${$(this).data('item_image_request_id')}`)
                .then(response => {
                    abcsetup.unblockUI();

                    abcsetup.alerts.show(`Image Request &ndash; ${$(this).data('description')}`, response.data.html);
                });
        });
    },
}
